import React from 'react'
import { useIntl } from 'react-intl'
import { getSVGImageUrl } from 'lib/image/imageUtils'

interface Props {
  width?: number
  height?: number
}

function VelocityIcon({ width = 14, height = 14 }: Props) {
  const intl = useIntl()
  return <img
    src={getSVGImageUrl('VFF_currency_symbol_RGB_red')}
    width={width}
    height={height}
    alt={intl.formatMessage({
      id: 'rYngFSymCj',
      defaultMessage: 'Velocity',
      description: 'Accessibility alt text for Velocity Frequent Flyer icon',
    })}
  />
}

export default VelocityIcon
